<template>
  <button
    class="text-orange-900/80 flex items-center justify-between gap-4 rounded-md px-3 py-2 text-left"
    :class="{
      'bg-white': !hasError,
      'bg-red-50': hasError,
    }"
  >
    <slot />
  </button>
</template>
<script setup lang="ts">
defineProps<{
  hasError?: boolean;
}>();
</script>
